import React, { useState, FC, useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import styles from '../AnnotationForm.module.scss';

type Props = {
  parentIds: string[];
  showCancel?: boolean;
  addedFailed: boolean;
  addedSuccessfully: boolean;
  disabled: boolean;
  message?: string;
  onCancelComment: () => void;
  onSaveComment: (parentIds: string[], message: string) => void;
};

const AddComment: FC<Props> = ({
  parentIds,
  showCancel = true,
  addedFailed,
  addedSuccessfully,
  disabled,
  message,
  onCancelComment,
  onSaveComment
}) => {
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const saveComment = () => {
    setIsLoading(true);
    onSaveComment(parentIds, comment);
  };

  useEffect(() => {
    if (message) {
      setComment(message);
    }
    if (addedSuccessfully && isLoading) {
      setIsLoading(false);
      setComment('');
      onCancelComment();
    }

    if (addedFailed && isLoading) {
      setIsLoading(false);
    }
  }, [addedFailed, addedSuccessfully, isLoading, onCancelComment, message]);

  return (
    <div className={styles.addCommentContainer}>
      <Form.Item className={styles.comment}>
        <Input.TextArea
          disabled={disabled}
          placeholder='Enter Comment'
          value={comment}
          onChange={e => setComment(e.target.value)}
          ref={TextArea => TextArea && TextArea.focus()}
        />
      </Form.Item>
      <div className={styles.addCommentActions}>
        <Button loading={isLoading} size={'middle'} disabled={!comment.length} key='submit' htmlType='submit' onClick={saveComment}>
          Save
        </Button>
        {showCancel && (
          <Button style={{ marginLeft: '1rem' }} size={'middle'} key='back' onClick={() => onCancelComment()}>
            Cancel
          </Button>
        )}
      </div>
    </div>
  );
};

export default AddComment;
